import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=f897757a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f897757a')) {
      api.createRecord('f897757a', component.options)
    } else {
      api.reload('f897757a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=f897757a&", function () {
      api.rerender('f897757a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fSorv4GTLcBg/JS/comp/openstreetmap.vue"
export default component.exports